<template>
  <WdsStack gap-sm direction-column>
    <WdsSelect
      v-model="selectedCountries"
      multi-select
      searchable
      class="tw-min-w-[150px]"
      data-test="tc-filter-country"
      :label="meta.filter.quickFilter ? '' : $t('Country of residence')"
      :list="countryOptions"
      :placeholder="$t('All locations')"
      :max-labels-visible="meta.filter.quickFilter ? 1 : 5"
      :loading="loading"
      can-deselect
      labels-primary
    >
      <template #option="{ option }">
        <WdsStack direction-row align-center gap-sm>
          <WdsIcon :size="16" :name="computeFlagIcon(option.value)" />
          {{ option.label }}
        </WdsStack>
      </template>
    </WdsSelect>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsIcon, WdsSelect, WdsStack } from '@worksome/wds-components'
import { computed, ModelRef } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import gql from 'graphql-tag'
import { $t } from '@/composables/translation'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'
import { computeFlagIcon } from '@/utils/ts-tools'

defineProps<{ meta: FilterMetaDataProp }>()

const selectedCountries: ModelRef<{ label: string; value: string }[]> = defineModel({
  default: () => [],
})

const TrustedContactCountriesQuery = gql`
  query TrustedContactCountriesFilterQuery {
    trustedContactCountries
  }
`

const { result, loading } = useQuery(TrustedContactCountriesQuery, null, {
  clientId: 'publicApi',
  fetchPolicy: 'cache-and-network',
})

const countryOptions = computed<{ label: string; value: string }[]>(() => {
  const countries = (result.value?.trustedContactCountries as string[]) ?? []

  return countries
    .map((isoCode) => {
      const upperCode = isoCode.toUpperCase()
      return {
        label: countriesGlobalVar[upperCode] ?? countriesGlobalVar[isoCode] ?? isoCode,
        value: upperCode,
      }
    })
    .sort((a, b) => a.label.localeCompare(b.label))
})
</script>
